import React, { Component } from "react";
import { Typography, Card, CardContent, CardMedia } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";

export var styles = function styles(theme) {
	return {
		menuRoot: {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.primary.contrastText,
			height: "100%",
			display: "flex",
			flexDirection: "column",
		},
		container: {
			flex: "0 0 100%",
			backgroundColor: "white",
			padding: "0px",
		},
		menuItem: {
			textAlign: "center",
			cursor: "pointer",
			"&:hover, & div:hover": {
				backgroundColor: theme.palette.primary.dark,
				transition: "0.3s",
			},
		},
		menuItemSelected: {
			backgroundColor: theme.palette.primary.dark,
		},
		logo: {
			height: "150px",
			width: "auto",
		},
		mainWrapper: {
			height: "100%",
			alignItems: "center",
			display: "flex",
			flexDirection: "column",
		},
		logoWrapper: {
			display: "flex",
			justifyContent: "center",
		},
		contentWrapper: {
			width: "80%",
			flex: "1",
		},
		navMenu: {
			display: "flex",
			justifyContent: "center",
			border: "1px solid #ebebeb",
			borderLeftWidth: "0px",
			borderRightWidth: "0px",
		},
		card: {
			margin: "8px",
		},
		cardSplit: {
			display: "flex",
		},
		smallCardWrapper: {
			display: "flex",
			flex: "1",
			"& div": {
				flex: 1,
			},
		},
		verticalSplitSmall: {
			display: "flex",
			flex: "1",
			flexDirection: "column",
		},
		hoverCard: {
			"&:hover": {
				boxShadow: "0px 8px 12px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)",
				cursor: "pointer",
			},
		},
		cardImage: {
			height: "60px",
		},
	};
};

class MainSiteHome extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedTab: 0,
		};
	}

	render() {
		return (
			<div className={[this.props.classes.mainWrapper].join(" ")}>
				<div className={[this.props.classes.cardSplit].join(" ")}>
					<Card variant="elevation" style={{ flex: 1 }} className={[this.props.classes.card].join(" ")}>
						<CardContent>
							<Typography variant="h5" color="textSecondary">
								Advice from Mechanical Experts
							</Typography>
							<Typography variant="body1">We have an established team of mechanical experts that have been working in various fields of elevator technology since 1987. Our team seeks out solutions to problems without discarding the safety and quality of your equipment. Our number one priority is the future success of our clients; no amount of experience is enough to predict every possible issue that could arise, so we constantly focus on technical and safety improvement, creating new ideas with new products that can be part of your life.</Typography>
						</CardContent>
					</Card>
					<div className={[this.props.classes.verticalSplitSmall]}>
						<div className={[this.props.classes.smallCardWrapper]}>
							<Card className={this.props.classes.card} variant="elevation">
								<CardMedia image="/img/maintenance.jpg" title="Preventative maintenance" className={[this.props.classes.cardImage].join(" ")} />
								<CardContent>
									<Typography variant="h5" color="textSecondary">
										Maintenance
									</Typography>
									<Typography variant="body1">{"Routine, necessary maintenance handled with care & professionalism."}</Typography>
								</CardContent>
							</Card>
							<Card className={this.props.classes.card} variant="elevation">
								<CardMedia image="/img/repair.jpg" style={{ backgroundPosition: "0px -110px" }} title="Preventative maintenance" className={[this.props.classes.cardImage].join(" ")} />
								<CardContent>
									<Typography variant="h5" color="textSecondary">
										Repair
									</Typography>
									<Typography variant="body1">Any form of repairs, internal or external, to keep your business running smoothly.</Typography>
								</CardContent>
							</Card>
						</div>
						<div className={[this.props.classes.smallCardWrapper]}>
							<Card className={this.props.classes.card} variant="elevation">
								<CardMedia image="/img/modernization.png" title="Modernization" className={[this.props.classes.cardImage].join(" ")} />
								<CardContent>
									<Typography variant="h5" color="textSecondary">
										Modernization
									</Typography>
									<Typography variant="body1">Updating, renovating, and upgrading to stay modern.</Typography>
								</CardContent>
							</Card>
							<Card
								onClick={() => {
									document.location.href = "/login";
								}}
								className={[this.props.classes.card, this.props.classes.hoverCard].join(" ")}
								variant="elevation">
								<CardMedia image="/img/mail.jpg" title="Client Portal" style={{ backgroundPosition: "0px -45px" }} className={[this.props.classes.cardImage].join(" ")} />
								<CardContent>
									<Typography variant="h5" color="textSecondary">
										Client Portal
									</Typography>
									<Typography variant="body1">24/7 visibility into recent work done, recommendations for future work, and any outstanding issues.</Typography>
								</CardContent>
							</Card>
						</div>
					</div>
				</div>
				<Card variant="elevation" className={[this.props.classes.card].join(" ")}>
					<CardContent>
						<Typography variant="h5" color="textSecondary">
							{"Qualified & Certified"}
						</Typography>
						<Typography variant="body1">
							We have an established team of mechanical experts that have been working in various fields of elevator technology since 1987. Our team seeks out solutions to problems without discarding the safety and quality of your equipment. Our workers are qualified and certified engineers and technicians in the United States with a history well-nourished in experience and dedication. Our number one priority is the future success of our clients; no amount of experience is enough to predict every possible issue that could arise, so we constantly focus on technical and safety
							improvement, creating new ideas with new products that can be part of your life.
						</Typography>
					</CardContent>
				</Card>
				<Card variant="elevation" className={[this.props.classes.card].join(" ")}>
					<CardContent>
						<Typography variant="h5" color="textSecondary">
							We're Your Neighbors
						</Typography>
						<Typography variant="body1">
							We are an important elevator company in South Florida for you. We not only want you to purchase our equipment, but also want to be your solution. We give you the most for your money with high quality parts and enhanced service available 24 hours. We understand the need to help you have an elevator running smoothly at an affordable price. We pride ourselves on providing excellent customer service that involves listening to customers’ concerns and offering various solutions in a quick and timely manner. With our many years of experience, this gives us the opportunity
							to introduce our various solutions to your elevators made just for you.
						</Typography>
					</CardContent>
				</Card>
				<Card variant="elevation" className={[this.props.classes.card].join(" ")}>
					<CardContent>
						<Typography variant="h5" color="textSecondary">
							No-Cost Investigation
						</Typography>
						<Typography variant="body1">We can visit your building at no cost and we will help you not only to find the solution to your problem, but also identify the cause so that the issue can be prevented in the future. As our first priority, you can consult with our technicians at our local store so that we can ensure a sound investment.</Typography>
					</CardContent>
				</Card>
				<Card variant="elevation" className={[this.props.classes.card].join(" ")}>
					<CardContent>
						<Typography variant="h5" color="textSecondary">
							Satisfaction Guaranteed
						</Typography>
						<Typography variant="body1">We guarantee that you will feel confident with our service and we want to learn from you because you are the ones that give us the experience. As to reach this goal, we build our own fixtures. This gives you and us the peace of mind of knowing the product will work and it will work efficiently.</Typography>
					</CardContent>
				</Card>
			</div>
		);
	}
}

export default withStyles(styles, { withTheme: true })(MainSiteHome);
